import React from 'react';

const ACTION_LABELS = {
  buy: '买入',
  add: '加仓',
  hold: '持有',
  reduce: '减仓'
};

const EFFECT_LABELS = {
  support: '支持',
  neutral: '中性',
  caution: '谨慎',
  oppose: '不利'
};

function ActionSummary({ summary }) {
  if (!summary) return null;
  return (
    <div className="exposure-action-summary">
      {Object.entries(ACTION_LABELS).map(([key, label]) => {
        const item = summary[key] || {};
        return (
          <div className={`exposure-action-overview tone-${item.tone || 'neutral'}`} key={key}>
            <span>{label}</span>
            <strong>{item.label || '中性'}</strong>
            <small>
              支持 {item.counts?.support || 0} · 谨慎 {item.counts?.caution || 0}
            </small>
          </div>
        );
      })}
    </div>
  );
}

function FactorCard({ factor }) {
  const actions = factor.actions || {};
  return (
    <article className={`exposure-factor tone-${factor.tone || 'unknown'}`}>
      <div className="exposure-factor-head">
        <div>
          <h4>{factor.label}</h4>
          <span className={`exposure-level tone-${factor.tone || 'unknown'}`}>
            风险 {factor.level_label || '待确认'}
          </span>
        </div>
        <div className="exposure-confidence">
          <span>可信度 {factor.confidence?.label || '—'}</span>
          {factor.risk_score != null ? <strong>{factor.risk_score}/100</strong> : <strong>待确认</strong>}
        </div>
      </div>

      <p className="exposure-assessment">{factor.assessment}</p>

      {factor.evidence?.length ? (
        <ul className="exposure-evidence">
          {factor.evidence.map((item, index) => <li key={`${factor.key}-e-${index}`}>{item}</li>)}
        </ul>
      ) : null}

      <div className="exposure-actions">
        {Object.entries(ACTION_LABELS).map(([key, label]) => {
          const item = actions[key];
          if (!item) return null;
          return (
            <div className={`exposure-action-row effect-${item.effect || 'neutral'}`} key={key}>
              <span>{label}</span>
              <em>{EFFECT_LABELS[item.effect] || '中性'}</em>
              <p>{item.text}</p>
            </div>
          );
        })}
      </div>
    </article>
  );
}

export default function RiskExposurePanel({ profile }) {
  if (!profile?.factors?.length) {
    return <p className="decision-muted">暂无足够披露数据生成风险暴露画像。</p>;
  }

  const quality = profile.data_quality || {};
  return (
    <div className="risk-exposure-panel">
      <div className="exposure-meta">
        <span>已识别 {quality.known_factors || 0}/{quality.total_factors || 6} 类</span>
        <span>综合可信度 {quality.confidence?.label || '—'}</span>
        {quality.latest_report_period ? <span>报告期 {quality.latest_report_period}</span> : null}
        {quality.stale ? <span className="stale">报告时效偏旧</span> : null}
      </div>

      <ActionSummary summary={profile.action_summary} />

      <div className="exposure-factor-grid">
        {profile.factors.map((factor) => <FactorCard factor={factor} key={factor.key} />)}
      </div>

      <p className="decision-muted exposure-disclaimer">{profile.disclaimer}</p>
    </div>
  );
}
